export const HEADER_POPOVER_HEIGHT = 180;
export const HEADER_POPOVER_WIDTH = 371;

export function getHeaderPopoverMinTop() {
  const topbar = document.querySelector('.md-toolbar.main-header');
  if (topbar) {
    return topbar.getBoundingClientRect().bottom;
  }
  return 8;
}

/** Căn popover user/group theo viewport (giống messenger user info popover). */
export function positionHeaderPopover(anchorEl, options = {}) {
  const popoverHeight = options.height || HEADER_POPOVER_HEIGHT;
  const popoverWidth = options.width || HEADER_POPOVER_WIDTH;
  const gap = options.gap != null ? options.gap : 10;
  const viewportPadding = options.viewportPadding != null ? options.viewportPadding : 8;
  const minTop = options.minTop != null ? options.minTop : getHeaderPopoverMinTop();

  const rect = anchorEl.getBoundingClientRect();
  const spaceAbove = rect.top - minTop;
  const placement = spaceAbove >= popoverHeight + gap ? 'top' : 'bottom';
  let top = placement === 'top'
    ? rect.top - popoverHeight - gap
    : rect.bottom + gap;
  let left = rect.left;
  const maxLeft = window.innerWidth - popoverWidth - viewportPadding;
  left = Math.max(viewportPadding, Math.min(left, maxLeft));
  top = Math.max(minTop + viewportPadding, top);
  const maxTop = window.innerHeight - popoverHeight - viewportPadding;
  if (top > maxTop) {
    top = maxTop;
  }

  return {
    placement,
    style: {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
    },
  };
}
